import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DialogUtilityService {
  private closeProjectBriefDialogSubject = new Subject<void>();
  closeProjectBriefDialog$ = this.closeProjectBriefDialogSubject.asObservable();
  private closeProjectPlanDialogSubject = new Subject<void>();
  closeProjectPlanDialog$ = this.closeProjectPlanDialogSubject.asObservable();
  constructor(private dialog: MatDialog) {}

  handleCloseDialog(): void {
    this.dialog.closeAll();
  }
  closeProjectBriefDialog() {
    this.closeProjectBriefDialogSubject.next();
  }
  closeProjectPlanDialog() {
    this.closeProjectPlanDialogSubject.next();
  }
}
